import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import AboutAreaFive from "../components/AboutAreaFive";
import AboutAreaSix from "../components/AboutAreaSix";
import BannerFive from "../components/BannerFive";
import FooterFour from "../components/FooterFour";
import NavbarFour from "../components/NavbarFour";
import ServiceAreaFive from "../components/ServiceAreaFive";

const HomeFive = () => {
  return (
    <>
      <SEO canonical="/" {...PAGES["/"]} />
      <NavbarFour />
      <BannerFive />
      <ServiceAreaFive />
      <AboutAreaFive />
      <AboutAreaSix />

      <FooterFour />
    </>
  );
};

export default HomeFive;
